import { getHeaders, SubmissionURL } from './config';
import { checkStatus, getData, getRawData } from './normalizer';
import {
    AdjustmentRequest,
    OtherReviewRequest,
    RemovalReviewRequest,
    CancellationReviewRequest,
    NonMoniedReviewRequest,
    ExtensionRequest,
    AdjustmentReviewRequest,
} from 'types/endorsements.type';

export async function createRemovalEndorsement(submissionId: string, payload: {}) {
    const url = `${SubmissionURL}/submission/${submissionId}/removal-endorsement`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus).then(getData);
}

export async function createNonMoniedEndorsement(submissionId: string, payload: {}) {
    const url = `${SubmissionURL}/submission/${submissionId}/non-monied-endorsement`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus).then(getData);
}

export async function createAdjustmentEndorsement(submissionId: string, payload: AdjustmentRequest) {
    const url = `${SubmissionURL}/submission/${submissionId}/adjustment-endorsement`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus).then(getData);
}

export async function sendAdjustmentReview(submissionId: string, payload: AdjustmentReviewRequest) {
    const url = `${SubmissionURL}/endorsement/${submissionId}/adjustment-review`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus);
}

export async function sendNonMoniedReview(submissionId: string, payload: NonMoniedReviewRequest) {
    const url = `${SubmissionURL}/endorsement/${submissionId}/non-monied-review`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus);
}

export async function sendRemovalReview(submissionId: string, payload: RemovalReviewRequest) {
    const url = `${SubmissionURL}/endorsement/${submissionId}/removal-review`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus);
}

export async function getReturnedPremium(submissionId: string) {
    const url = `${SubmissionURL}/endorsement/${submissionId}/returned-premium`;
    const options = {
        method: 'GET',
        headers: getHeaders(),
    };
    return fetch(url, options).then(checkStatus).then(getRawData);
}

export async function createExtensionEndorsement(id: string, payload: ExtensionRequest) {
    return fetch(`${SubmissionURL}/submission/${id}/extension-endorsement`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    })
        .then(checkStatus)
        .then(getData);
}

export async function createCancellationEndorsement(submissionId: string, payload: OtherReviewRequest) {
    const url = `${SubmissionURL}/submission/${submissionId}/cancellation-endorsement`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus);
}

export async function sendCancellationReview(submissionId: string, payload: CancellationReviewRequest) {
    const url = `${SubmissionURL}/endorsement/${submissionId}/cancellation-review`;
    const options = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    };
    return fetch(url, options).then(checkStatus);
}
